// utils/notifier.ts
type NotificationPosition = {
  vertical: 'top' | 'bottom'
  horizontal: 'left' | 'center' | 'right'
}

type NotificationConfig = {
  variant?: 'success' | 'error' | 'warning'
  position?: NotificationPosition
}

let _enqueueSnackbar: any = null

export const initNotifier = (enqueueSnackbar: any) => {
  _enqueueSnackbar = enqueueSnackbar
}

export const notify = (
  message: string,
  config?: NotificationConfig
) => {
  if (!_enqueueSnackbar) {
    console.error('Notifier not initialized')
    return
  }

  const defaultConfig = {
    variant: 'success' as const,
    position: {
      vertical: 'bottom' as const,
      horizontal: 'center' as const
    }
  }
  
  const mergedConfig = {
    ...defaultConfig,
    ...config,
    position: {
      ...defaultConfig.position,
      ...config?.position
    }
  }

  _enqueueSnackbar(message, { 
    variant: mergedConfig.variant,
    anchorOrigin: mergedConfig.position
  })
}